import React from 'react';

import PropTypes from 'prop-types';

import { 
    Box,
    Grid,
    Select,
    LinearProgress,
    Typography,
    Alert,
	AlertTitle,
} from '@mui/material';

import TypographyKwik from '../../Typography';

import api from '../../../api';
import Loading from '../../Loading';
import Dialog360UsageChart from '../../Recharts/Dialog360UsageChart';
import useNotification from '../../Notification';

import './index.css';


function LinearProgressWithLabel(props) {
	return (
		<Box sx={{ display: "flex", alignItems: "center"}}>
			<Box sx={{ width: "100%", mr: 1 }} className="usage-progress-bar">
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography variant="body2" color="text.secondary">
					{`${Math.round(props.value,)}%`}
				</Typography>
			</Box>
		</Box>
	);
}

LinearProgressWithLabel.propTypes = {
	value: PropTypes.number.isRequired,
};


class Usage extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			loading  : true,
			data     : [],
			progress : 0,
		};

		this.months = [
			'Jan', 
			'Fev', 
			'Mar', 
			'Abr', 
			'Mai', 
			'Jun', 
			'Jul', 
			'Ago', 
			'Set', 
			'Out', 
			'Nov', 
			'Dez'
		];

		this.fullMonths = [
			'Janeiro', 
			'Fevereiro', 
			'Março', 
			'Abril', 
			'Maio', 
			'Junho', 
			'Julho', 
			'Agosto', 
			'Setembro', 
			'Outubro', 
			'Novembro', 
			'Dezembro'
		];
	}

	getBalance = () => {
	    api.get(`/api/enterprises/${this.props.enterpriseId}/whatsapp/usage/`)
	        .then((res) => {
	            if (res.status !== 200) {
	                useNotification(
	                    "Atenção",
	                    "Erro ao buscar dados de consumo. Por favor, tente novamente mais tarde.",
	                    "warning"
	                );
	                throw new Error("Failed fetching usage...");
	            }

	            const data = {};
	            let packageProgress = 0;

	            if (res.data.length > 0) {
	                res.data.slice(-13).forEach((row) => {
	                    const date = new Date(row.period_date);
						const month = this.months[date.getUTCMonth()];
						const year = date.getUTCFullYear().toString().slice(-2);

	                    const business = row.business_initiated_quantity;
	                    const user = row.user_initiated_quantity;
	                    
	                    const sentMessages = row.meta_regular_messages > 0 ? row.meta_regular_messages : row.sent_messages;
	                    const marketing = row.meta_marketing > 0 ? row.meta_marketing : row.marketing;
	                    const utility = row.meta_utility > 0 ? row.meta_utility : row.utility;
	                    const authentication = row.meta_authentication > 0 ? row.meta_authentication : row.authentication;

	                    const key = date.toISOString();

	                    if (!(key in data)) {
	                        data[key] = {
	                            name: `${month} ${year}`,
	                            "Total": 0,
	                            "Ativo": 0,
	                            "Receptivo": 0,
	                            "Serviço": 0,
	                            "Marketing": 0,
	                            "Utilidade": 0,
	                            "Autenticação": 0,
	                        };
	                    }

	                    data[key]["Total"] += business + user;
	                    data[key]["Ativo"] += business;
	                    data[key]["Receptivo"] += user;
	                    data[key]["Serviço"] += sentMessages;
	                    data[key]["Marketing"] += marketing;
	                    data[key]["Utilidade"] += utility;
	                    data[key]["Autenticação"] += authentication;

	                    // Progress based on the latest month
	                    packageProgress = ((business + user) * 100) / 1000;
	                });

	                const sortedData = Object.keys(data)
	                    .sort()
	                    .map((key) => data[key]);

	                this.setState({
	                    loading: false,
	                    data: sortedData,
	                    progress: Math.min(packageProgress, 100),
	                });

	                return;
	            }

	            this.setState({
	                loading: false,
	                data: [],
	                progress: 0,
	            });
	        })
	        .catch((err) => {
	            console.error(err);

	            this.setState({
	                loading: false,
	                data: [],
	                progress: 0,
	            });

	            useNotification(
	                "Atenção",
	                "Erro ao buscar dados de consumo. Por favor, tente novamente mais tarde.",
	                "warning"
	            );
	        });
	};

	componentWillMount() {
        this.getBalance()
	}

	render() {
		const today = new Date();
		const month = this.fullMonths[today.getMonth()];
		const year  = today.getFullYear().toString();

		return (
			<>
	            <Loading loading={this.state.loading} message="Sincronizando consumo. Isto pode levar alguns segundos..."/>
	            {! this.state.loading &&
	                <Box className='whatsapp-consume'>
	                    <Box style={{ 
							fontSize: "19px",
							fontWeight: "bold",
							color: "#21446c",
							textAlign: "center",
							marginTop: "1rem",
	                    }}>
	                        Histórico de Consumo WhatsApp
	                    </Box>
	                    <Box sx={{ 
						    marginTop: ".5rem",
						    fontSize: "15px",
						    textAlign: "center"
						}}>
						    Acompanhe o uso mensal do canal WhatsApp.

						    <a
						        href={`https://business.facebook.com/latest/whatsapp_manager/insights?asset_id=${this.props.wabaId}`}
						        target="_blank"
						        rel="noopener noreferrer"
						        style={{
						            marginLeft: "8px",
						            color: "#1976d2",
						            textDecoration: "underline",
						            cursor: "pointer",
						        }}
						    >
						        Clique aqui para ver no Facebook Business.
						    </a>
						</Box>
	                    {/*<Box ml={13} mr={6} mt={3} style={{ textAlign: "right" }}>
	                        <LinearProgressWithLabel
	                            style={{
	                                height: "3vh",
	                                borderRadius: "3px"
	                            }}
	                            color={this.state.progress >= 75 ? "secondary" : "primary"}
	                            value={this.state.progress}
	                        />
	                    </Box>
	                    {this.state.progress >= 75 && this.state.progress < 100 &&
	                        <Box mt={1}>
	                            <TypographyKwik align="center"
	                                text="Você está prestes a atingir o limite do seu pacote. 
	                                	  Para cada atendimento realizado fora do limite, 
	                                	  serão cobrados custos extras."
	                                color="red"
	                                fontWeight="500"
	                            />
	                        </Box>
	                    }
	                    <Box mt={7} style={{ 
							fontSize   : "19px",
							fontWeight : "bold",
							color      : "#21446c",
							textAlign  : "center" 
	                    }}>
	                        Histórico dos Atendimentos e Mensagens - Canal WhatsApp
	                    </Box>*/}
	                    <Box className="usage-history-chart-container" 
	                    	mt={2} p={3} height={"50vh"}>
	                        <Dialog360UsageChart
	                            data={this.state.data}
	                        />
	                    </Box>
	                    <Box sx={{ padding: "0 1rem 1rem 1rem" }}>
						    <Alert severity="info" sx={{
						        width: '100%',
						        '& .MuiAlert-message': {
						            width: '100%',
						        },
						    }}>
						        <AlertTitle>Entenda os indicadores</AlertTitle>

						        <Box
						            sx={{
						                display: 'flex',
						                gap: '3rem',
						            }}
						        >
						            {/* Atendimentos */}
						            <Box sx={{ flex: 1 }}>
						                <Typography
						                    variant="subtitle2"
						                    sx={{ fontWeight: 600, margin: ".75rem 0" }}
						                >
						                    Atendimentos
						                </Typography>

						                <Typography variant="body2" sx={{ marginBottom: ".5rem"}}>
						                    <strong>Total:</strong> quantidade total de atendimentos contabilizados pelo Kwik no período.
						                </Typography>

						                <Typography variant="body2" sx={{ marginBottom: ".5rem"}}>
						                    <strong>Ativo:</strong> atendimentos iniciados pela empresa, através de templates WhatsApp.
						                </Typography>

						                <Typography variant="body2">
						                    <strong>Receptivo:</strong> atendimentos iniciados pelo cliente.
						                </Typography>
						            </Box>

						            {/* Mensagens */}
						            <Box sx={{ flex: 1 }}>
						                <Typography
						                    variant="subtitle2"
						                    sx={{ fontWeight: 600, marginTop: "-1.5rem", marginBottom: ".75rem" }}
						                >
						                    Mensagens Enviadas
						                </Typography>

						                <Typography variant="body2" sx={{ marginBottom: ".5rem" }}>
						                    <strong>Serviço:</strong> quantidade de mensagens enviadas pela empresa, durante atendimentos, pelo canal WhatsApp.
						                </Typography>

						                <Typography variant="body2" sx={{ marginBottom: ".5rem" }}>
						                    <strong>Marketing:</strong> mensagens classificadas pela Meta para ações promocionais, ofertas ou campanhas.
						                </Typography>

						                <Typography variant="body2" sx={{ marginBottom: ".5rem" }}>
						                    <strong>Utilidade:</strong> mensagens relacionadas a uma ação ou serviço solicitado pelo cliente, como atualizações de pedidos, pagamentos ou agendamentos.
						                </Typography>

						                <Typography variant="body2">
						                    <strong>Autenticação:</strong> mensagens utilizadas para validação de identidade, como códigos de acesso ou confirmação.
						                </Typography>
						            </Box>
						        </Box>
						    </Alert>
						</Box>
	                </Box>
	            }
	        </>
		);
	}
}

export default Usage;
